<template>
	
<com-section v-on:back="$emit('back')" v-on:next="$emit('next')" :section="section" :intro="section.intro" v-on:introducing="$emit('introducing')" v-on:introduced="$emit('introduced')">

	<slot></slot>

	<portal to="modal" v-if="$isPatient">

		<div class="health-modal" v-if="is.info">

			<div class="health-modal-overlay" v-on:click="is.info = false"></div>

			<div class="health-modal-panel">

				<div class="health-modal-header">

					<div class="health-modal-title">{{ is.info.title }}</div>

					<button class="health-modal-close" v-on:click="is.info = false">&times;</button>

				</div>

				<div class="health-modal-body text" v-html="parsedInfoText"></div>

			</div>

		</div>

	</portal>

	<div class="risk-intro" v-if="$isPatient && section.patient_intro">
		<div class="risk-intro-text" v-html="parsedPatientIntro" v-on:click="onSectionLinkClick"></div>
	</div>

	<div class="risk" v-if="!$isPatient">

		<com-personal v-on:next="onNext" :completed="step > 1" :section="section" />
		<com-lifestyle v-on:next="onNext" :completed="step > 2" :section="section" :active="step > 1" />
		<com-density v-on:next="onNext" :completed="step > 3" :section="section" :active="step > 2" />
		<com-risk v-on:next="onNext" :section="section" :active="step > 3" v-on:cates="is.viewCates = true" v-on:graph="is.viewGraph = true" />

		<div class="risk-skeleton"></div>

		<div class="risk-cates" v-if="is.viewCates">

			<div class="risk-cates-close" v-on:click="is.viewCates = false"></div>

			<com-cates :max="100" :bad="score" title="Chance of breaking a bone" action="break a bone" />

		</div>

		<div class="risk-graph" v-if="is.viewGraph">

			<div class="risk-graph-close" v-on:click="is.viewGraph = false"></div>

			<com-chart class="risk-graph-chart" :max="45" title="Major Fracture" type="m" />
			<com-chart class="risk-graph-chart" :max="25" title="Hip" type="h" />

		</div>

	</div>

	<div class="risk is-patient" v-if="$isPatient">

		<com-personal :completed="false" :section="section" v-on:info="onInfo($event, 'personal')" />
		<com-lifestyle :completed="false" :section="section" :active="true" v-on:info="onInfo($event, 'lifestyle')" />

		<div class="risk-skeleton"></div>

	</div>

	<com-check :text="section.proceed" v-if="!$isPatient && step > 3 && !is.viewCates && !is.viewGraph" :info="section.proceedInfo" v-on:click.native="$emit('next')" />

</com-section>

</template>

<script>

import comCates from './common/Cates'
import comChart from './common/Chart'

import comSection from '@/components/tool/common/Section'

import comPersonal from './risk/Personal'
import comLifestyle from './risk/Lifestyle'
import comDensity from './risk/Density'
import comRisk from './risk/Risk'

import comCheck from './common/Check'

import sectionLinks from '@/mixin/sectionlinks'

export default {

	props: ['section'],

	mixins: [sectionLinks],

	data: function() {

		return {
			is: {
				viewCates: false,
				viewGraph: false,
				info: false
			},
			step: 1
		}

	},

	components: {
		'com-section': comSection,
		'com-personal': comPersonal,
		'com-lifestyle': comLifestyle,
		'com-density': comDensity,
		'com-risk': comRisk,
		'com-check': comCheck,
		'com-cates': comCates,
		'com-chart': comChart
	},

	computed: {

		score: function() {

			return Math.round(this.frax('major'))

		},

		parsedPatientIntro: function() {

			return this.parseSectionLinks(this.section.patient_intro)

		},

		parsedInfoText: function() {

			if (!this.is.info || !this.is.info.text) return ''

			var text = this.is.info.text
				.replace(/<br\s*\/?>/gi, '\n')
				.replace(/<\/p\s*>\s*<p[^>]*>/gi, '\n\n')
				.replace(/<p[^>]*>/gi, '')
				.replace(/<\/p\s*>/gi, '')

			var lines = text.split(/\r?\n/)
			var out = []
			var depth = 0
			var inParagraph = false
			var k

			var closeAll = function() {
				while (depth > 0) {
					out.push('</li></ul>')
					depth--
				}
			}

			var closeParagraph = function() {
				if (inParagraph) {
					out.push('</p>')
					inParagraph = false
				}
			}

			for (var i = 0; i < lines.length; i++) {
				var line = lines[i].trim()
				var m = line.match(/^(#+)\s*(.*)$/)

				if (m) {
					closeParagraph()
					var D = m[1].length
					if (D > depth) {
						for (k = depth; k < D; k++) out.push('<ul>')
					} else if (D === depth) {
						out.push('</li>')
					} else {
						out.push('</li>')
						for (k = depth; k > D; k--) out.push('</ul></li>')
					}
					out.push('<li>' + m[2])
					depth = D
				} else if (line === '') {
					closeAll()
					closeParagraph()
				} else {
					closeAll()
					if (!inParagraph) {
						out.push('<p>')
						inParagraph = true
					} else {
						out.push(' ')
					}
					out.push(line)
				}
			}

			closeAll()
			closeParagraph()

			return out.join('')

		}

	},

	methods: {

		onNext: function() {

			this.step++

		},

		onInfo: function(key, group) {

			var icons = this.section[group] ? this.section[group].info : null

			if (icons && icons[key]) {

				this.is.info = { title: this.section[group].icon[key], text: icons[key] }

			}

		}

	}
	
}

</script>

<style scoped>

.risk {
	width: 100%;
	height: 594px;
	display: flex;
	flex-wrap: wrap;
}

.risk-skeleton {
	position: absolute;
	top: -12px;
	left: calc(50% - 130px);
	width: 259px;
	height: 610px;
	background-image: url(~@/assets/aid/risk/skeleton.svg);
	z-index: 1;
	pointer-events: none;
}

.risk-graph,
.risk-cates {
	position: absolute;
	z-index: 10000;
	background-color: rgba(255, 255, 255, 0.95);
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: -12px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}

.risk-graph-chart {
	margin: 0px 24px;
}

.risk-intro {
	margin-bottom: 24px;
}

.risk-intro-text {
	font-size: 18px;
	color: #343434;
	line-height: 28px;
	font-weight: 300;
}

.risk.is-patient {
	height: 297px;
}

.risk.is-patient .risk-skeleton {
	height: 320px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: bottom center;
	top: -12px;
}

.is-mobile .risk.is-patient {
	height: auto;
	flex-direction: column;
}

.is-mobile .risk.is-patient .risk-skeleton { display: none; }

.risk-graph-close,
.risk-cates-close {
	position: absolute;
	right: 24px;
	top: 64px;
	width: 42px;
	margin-top: -48px;
	background-color: #F8A533;
	border-radius: 21px;
	height: 42px;
	cursor: pointer;
	background-image: url(~@/assets/aid/improve/icon.close.svg);
	background-repeat: no-repeat;
	background-position: 50% 50%;
}

</style>

<style>

.risk-intro-hint {
	margin-top: 16px;
	opacity: 0.5;
}

.health-modal-body.text {
	font-size: 18px;
	color: #343434;
	line-height: 28px;
	font-weight: 300;
	flex-direction: column;
	align-items: flex-start;
}

.health-modal-body.text p { margin-bottom: 12px; }
.health-modal-body.text ul { padding-left: 20px; margin-bottom: 12px; }
.health-modal-body.text li { margin-bottom: 4px; }

</style>